import { render, staticRenderFns } from "./ConstructionWorkerShowDetailsTab.vue?vue&type=template&id=d9f0afbe"
import script from "./ConstructionWorkerShowDetailsTab.vue?vue&type=script&lang=ts"
export * from "./ConstructionWorkerShowDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports